import CleanChart from "@components/Charts/CleanChart";
import { ALGOS_E } from "@constants/Algos";
import useChartLiveDataSource, {
  CleanChartValueConverter,
} from "@components/Charts/ChartLiveDataSource";
import {
  CleanChartDataset,
  ICleanChartValue,
  NullableChartPeriod,
} from "@components/Charts/CleanChart.control";
import useChartPeriodControl from "@components/Charts/CleanChartPeriod.control";
import { useCallback, useEffect, useState } from "react";
import { wlpStatisticApi } from "../../utils";
import styles from "./RecentHashrateChart.module.scss";

interface RecentHashrateChartProps {
  onActiveMinersChanged?: (value: number | null) => void;
}

interface WlpChartValue {
  speed: number;
}

const converter: CleanChartValueConverter<WlpChartValue> = (
  timeInSec,
  value
) => {
  const result: ICleanChartValue[] = [];
  result.push({
    datasetIndex: 0,
    timeInSec,
    value: value.speed,
    state: -1,
  });
  return result;
};

function RecentHashrateChart({ onActiveMinersChanged }: RecentHashrateChartProps) {
  const [isLoading, setLoading] = useState(false);
  const [datasets, setDatasets] = useState<CleanChartDataset[]>([]);
  const liveDataSource = useChartLiveDataSource<WlpChartValue>(converter);

  const load = useCallback(async (_period: NullableChartPeriod) => {
    setLoading(true);

    try {
      const response = await wlpStatisticApi.getRecentHashrate();
      const chartData = Array.isArray(response.Record) ? response.Record : [];

      console.log("RecentHashrateChart", response, chartData);

      setDatasets([
        {
          label: "wlp-recent-hashrate",
          data: chartData as unknown as CleanChartDataset["data"],
        },
      ]);

      onActiveMinersChanged?.(response.ActiveMinerCount ?? null);
    } catch {
      setDatasets([]);
      onActiveMinersChanged?.(null);
    } finally {
      setLoading(false);
    }
  }, [onActiveMinersChanged]);

  const periodControl = useChartPeriodControl({
    onPeriodChanged: load,
  });

  useEffect(() => {
    load(periodControl.period);
  }, []);

  return (
    <CleanChart
      className={styles.chart}
      showLegend
      showY1Scales={false}
      isLoading={isLoading}
      datasets={datasets}
      liveDataSource={liveDataSource}
      periodControl={periodControl}
      poolHash={ALGOS_E.SHA256}
      onVisible={() => load(periodControl.period)}
    />
  );
}

export { RecentHashrateChart };
